import { useMutation } from '@tanstack/react-query'
import { authApi } from '../api/authApi'

export const useResendVerification = () => {
  return useMutation({
    mutationFn: (email: string) => authApi.resendVerification(email),
  })
}
